import type { PortalWidget } from "@entrilia/shared/api/portalWidgetsTypes";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { api } from "../../../api/client";
import useClientContext from "../../../contexts/useClientContext";
import { pageRoutes } from "../../../routes";
import WidgetPreviewCard from "../../widgets/mobile/WidgetPreviewCard";
import NewsWidgetContent from "../NewsWidgetContent";

interface Props {
  widgetSettings: PortalWidget;
}

const getLatestNews = (signal?: AbortSignal) => api.investorCommunications.search({ paging: { size: 1 } }, signal);

const NewsWidgetPreviewCard = ({ widgetSettings }: Props) => {
  const { clientCode } = useClientContext();
  const [newsPage, fetchError] = useFetch(getLatestNews);

  const newsPagePath = `/${clientCode}/${pageRoutes.news}`;

  return (
    <WidgetPreviewCard name={widgetSettings.name} viewAllTo={newsPagePath}>
      <NewsWidgetContent
        latestNews={newsPage?.items[0]}
        loading={newsPage === undefined}
        fetchError={fetchError}
        newsPagePath={newsPagePath}
        heroLayout
      />
    </WidgetPreviewCard>
  );
};

export default NewsWidgetPreviewCard;
